var map = {
	"./intelBg.png": "YMfO",
	"./intelBg_en.png": "5xTN",
	"./js/mobile": "TnL0",
	"./js/mobile.js": "TnL0",
	"./robot.gif": "BaWn",
	"./robot.png": "aHsp",
	"./serviceBg.png": "ZSlD"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fByr";


//////////////////
// WEBPACK FOOTER
// ./src/static ^\.\/.*$
// module id = fByr
// module chunks = 15